import React, { useContext, useMemo } from 'react';
import { IZCoreEmailTemplate, ZCoreEmailTemplate, EntityValidations, ISpecificEntityFormProps } from '../../types';
import styles from '../../styles/cr.module.scss';
import { CrTextField } from '../cr/CrTextField';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';

export class EmailTemplateFormValidations extends EntityValidations {
    public Subject: string = null;
    public Message: string = null;
}

export const EmailTemplateForm = (props: ISpecificEntityFormProps): React.ReactElement => {
    const { dataServices: { customFieldService, zCoreEmailTemplateService, contributorService } } = useContext(DataContext);
    const { lookupData, loadLookupData: { customFieldDfns, benefitTypes, entityStatuses, measurementUnits, projects, userProjects, users: { all: allUsers } } } = useContext(DataContext);

    useMemo(() => customFieldDfns(), [customFieldDfns]);
    useMemo(() => benefitTypes(), [benefitTypes]);
    useMemo(() => entityStatuses(), [entityStatuses]);
    useMemo(() => measurementUnits(), [measurementUnits]);
    useMemo(() => projects(), [projects]);
    useMemo(() => userProjects(), [userProjects]);
    useMemo(() => allUsers(), [allUsers]);

    const validateEntity = (template: IZCoreEmailTemplate): Promise<EmailTemplateFormValidations> => {
        const errors = new EmailTemplateFormValidations();

        if (template.Title === null || template.Title === '') {
            errors.Title = 'Template name is required';
            errors.Valid = false;
        }
        else
            errors.Title = null;

        if (template.Subject === null || template.Subject === '') {
            errors.Subject = 'Subject is required';
            errors.Valid = false;
        }
        else
            errors.Subject = null;

        if (template.Message === null || template.Message === '') {
            errors.Message = 'Message is required';
            errors.Valid = false;
        }
        else
            errors.Message = null;


        return Promise.resolve(errors);
    };

    return (
        <EntityForm<IZCoreEmailTemplate, EmailTemplateFormValidations>
            {...props}
            entityName="Email Template"
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: emailTemplate, ValidationErrors: errors } = formState;
                return (
                    <div>
                        <CrTextField
                            label="Name"
                            className={styles.formField}
                            required={true}
                            maxLength={255}
                            value={emailTemplate.Title}
                            onChange={(_, v) => changeHandlers.changeTextField(v, 'Title')}
                            errorMessage={errors.Title}
                        />
                        <CrTextField
                            label="Subject"
                            className={styles.formField}
                            required={true}
                            maxLength={255}
                            value={emailTemplate.Subject}
                            onChange={(_, v) => changeHandlers.changeTextField(v, 'Subject')}
                            errorMessage={errors.Subject}
                        />
                        <CrTextField
                            label="Message"
                            className={styles.formField}
                            value={emailTemplate.Message}
                            maxLength={3000}
                            onChange={(_, v) => changeHandlers.changeTextField(v, 'Message')}
                            errorMessage={errors.Message}
                            rows={15}
                            multiline
                        />

                    </div>
                );
            }}
            loadEntity={benefitId => zCoreEmailTemplateService.read(benefitId, true, true)}
            loadNewEntity={() => new ZCoreEmailTemplate()}
            loadEntityValidations={() => new EmailTemplateFormValidations()}
            onValidateEntity={validateEntity}
            onCreate={b => zCoreEmailTemplateService.create(b)}
            onUpdate={b => zCoreEmailTemplateService.update(b.ID, b)}
        //parentEntities={zCoreEmailTemplateService.parentEntities}
        // childEntities={[
        //     { ObjectParentProperty: 'Contributors', ParentIdProperty: 'BenefitID', ChildIdProperty: 'ContributorUserID', ChildService: contributorService },
        //     { ObjectParentProperty: 'CustomFields', ParentIdProperty: 'BenefitID', ChildIdProperty: 'CustomFieldDefnID', ChildService: customFieldService }
        // ]}
        />
    );
};
